import React, { Dispatch, FC, SetStateAction } from "react";
import { useOnChangeChildDispatch } from "utils/OnChange";
import { ThemeBuilderSection } from "../WidgetThemeBuilder/ThemeBuilderSection";
import { WidgetColorPicker } from "../WidgetThemeBuilder/WidgetColorPicker";
import { WidgetFontFamilyPicker } from "../WidgetThemeBuilder/WidgetFontFamilyPicker";
import { WidgetFontSizePicker } from "../WidgetThemeBuilder/WidgetFontSizePicker";
import { WidgetFontStylePicker } from "../WidgetThemeBuilder/WidgetFontStylePicker";
import { WidgetFontWeightPicker } from "../WidgetThemeBuilder/WidgetFontWeightPicker";
import { SearchWidgetLineHeightPicker } from "./LineHeightPicker";
import { SearchWidgetTextTheme } from "./SearchWidgetTypes";

export interface SearchWidgetTextThemeBuilderProps {
    readonly label?: string;
    readonly theme: SearchWidgetTextTheme | undefined;
    readonly defaultTheme: SearchWidgetTextTheme | undefined;
    readonly onChange: Dispatch<SetStateAction<SearchWidgetTextTheme>>;
}

const EMPTY_THEME: SearchWidgetTextTheme = {};

const SearchWidgetTextThemeBuilderInner: FC<SearchWidgetTextThemeBuilderProps> = props => {
    const theme: SearchWidgetTextTheme = props.theme ?? EMPTY_THEME;
    const defaultTheme: SearchWidgetTextTheme = props.defaultTheme ?? EMPTY_THEME;

    const { onChange } = props;

    const handleColorChange = useOnChangeChildDispatch("color", onChange);
    const handleFontSizeChange = useOnChangeChildDispatch("fontSize", onChange);
    const handleFontFamilyChange = useOnChangeChildDispatch("fontFamily", onChange);
    const handleFontWeightChange = useOnChangeChildDispatch("fontWeight", onChange);
    const handleFontStyleChange = useOnChangeChildDispatch("fontStyle", onChange);
    const handleLineHeightChange = useOnChangeChildDispatch("lineHeight", onChange);

    return (
        <ThemeBuilderSection heading={props.label ?? "Text Style"} className="widget-text-theme-builder">
            <WidgetColorPicker key="color" value={theme.color} defaultValue={defaultTheme.color} onChange={handleColorChange} />
            <WidgetFontSizePicker key="fontSize" value={theme.fontSize} defaultValue={defaultTheme.fontSize} onChange={handleFontSizeChange} />
            <WidgetFontFamilyPicker key="fontFamily" value={theme.fontFamily} defaultValue={defaultTheme.fontFamily} onChange={handleFontFamilyChange} />
            <WidgetFontWeightPicker key="fontWeight" value={theme.fontWeight} defaultValue={defaultTheme.fontWeight} onChange={handleFontWeightChange} />
            <WidgetFontStylePicker key="fontStyle" value={theme.fontStyle} defaultValue={defaultTheme.fontStyle} onChange={handleFontStyleChange} />
            <SearchWidgetLineHeightPicker key="lineHeight" value={theme.lineHeight?.toString()} defaultValue={defaultTheme.lineHeight?.toString()} onChange={handleLineHeightChange} />
        </ThemeBuilderSection>
    );
};

export const SearchWidgetTextThemeBuilder = React.memo(SearchWidgetTextThemeBuilderInner);
